const regex = '[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*';

interface Options {
	readonly exact?: boolean;
}

export default function emailRegex(options?: Options): RegExp {
	return options?.exact ? new RegExp(`^${regex}$`) : new RegExp(regex, 'g');
}
